import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const TyreSkirt = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.pants.TyreSkirt.itemName}
      name={SS23.pants.TyreSkirt.itemName}
      price={SS23.pants.TyreSkirt.itemPrice}
      fabric={SS23.pants.TyreSkirt.itemFabric}
      src={SS23.pants.TyreSkirt.sizeChart}
      divId={SS23.pants.TyreSkirt.shopifyDivId}
      mainId={SS23.pants.TyreSkirt.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.pants.TyreSkirt.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.pants.TyreSkirt.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default TyreSkirt;
